import React from "react";

const AssistanceBoolComponent = props => {
  return <>{props.data.assistance ? "Sí" : "No"}</>;
};

export default AssistanceBoolComponent;
